export default {
  methods: {
    reservationSuccess() {
      console.log('[ reservationSuccess ] >-----------------------------------------')
      // facebook1
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        }
        if (!f._fbq) f._fbq = n
        n.push = n
        n.loaded = !0
        n.version = '2.0'
        n.queue = []
        t = b.createElement(e)
        t.async = !0
        t.src = v
        s = b.getElementsByTagName(e)[0]
        s.parentNode.insertBefore(t, s)
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
      fbq('init', '891770789994503')
      fbq('track', 'PageView')
      fbq('track', 'CompleteRegistration')

      // facebook2
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        }
        if (!f._fbq) f._fbq = n
        n.push = n
        n.loaded = !0
        n.version = '2.0'
        n.queue = []
        t = b.createElement(e)
        t.async = !0
        t.src = v
        s = b.getElementsByTagName(e)[0]
        s.parentNode.insertBefore(t, s)
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
      fbq('init', '891770789994503')
      fbq('track', 'PageView')
      fbq('track', 'Purchase', { value: 0.0, currency: 'USD' })

      // Google Pixel
      !(function gtag_report_conversion(url) {
        var callback = function () {
          if (typeof url != 'undefined') {
            window.location = url
          }
        }
        gtag('event', 'conversion', {
          send_to: 'AW-17906269543/dnTGCMS98OwbEOf6r9pC',
          event_callback: callback
        })
        return false
      })()

      // Google Analytics
      gtag('event', 'sign_up')

      // TikTok Pixel
      ttq.track('CompleteRegistration')
    },
    clickStore() {
      const isReport = localStorage.getItem('is_report')
      // if (isReport) return
      // facebook
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        }
        if (!f._fbq) f._fbq = n
        n.push = n
        n.loaded = !0
        n.version = '2.0'
        n.queue = []
        t = b.createElement(e)
        t.async = !0
        t.src = v
        s = b.getElementsByTagName(e)[0]
        s.parentNode.insertBefore(t, s)
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
      fbq('init', '891770789994503')
      fbq('track', 'PageView')
      fbq('track', 'ViewContent')

      // Google Pixel
      !(function gtag_report_conversion(url) {
        var callback = function () {
          if (typeof url != 'undefined') {
            window.location = url
          }
        }
        gtag('event', 'conversion', {
          send_to: 'AW-17906269543/0ZNJCP6e8ewbEOf6r9pC',
          event_callback: callback
        })
        return false
      })()

      // Google Analytics
      gtag('event', 'select_content')

      // TikTok Pixel
      ttq.track('ViewContent')
      localStorage.setItem('is_report', 1)
    }
  }
}
